(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip/assets/javascripts/betslips/rsystem.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip/assets/javascripts/betslips/rsystem.js');
"use strict";

const {
  useContext
} = React;
const {
  useSelector
} = ReactRedux;
const {
  selectRSystem
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  BetslipContext
} = svs.components.tipsen.betslip;
const {
  HedgesXsmallView,
  HedgesView
} = svs.components.tipsen.betslip.views;
const {
  getSystemLabelFromNumber
} = svs.components.sport.systems;
const RSystem = () => {
  const {
    couponId,
    isExtraSmall
  } = useContext(BetslipContext);
  const systemNum = useSelector(state => selectRSystem(state, couponId));
  const systemLabel = getSystemLabelFromNumber(systemNum);
  if (isExtraSmall) {
    return React.createElement(HedgesXsmallView, null, systemLabel);
  }
  return React.createElement(HedgesView, {
    icon: "r-system"
  }, React.createElement("span", null, systemLabel));
};
setGlobal('svs.components.tipsen.betslip.betslips.RSystem', RSystem);

 })(window);